module.exports = __webpack_public_path__ + "img/11.41a19ee6.jpg";